import {useTranslation} from 'react-i18next';

import {Box, Typography} from '@mui/material';

import peopleInOffice from '../../assets/chat_based_talent_survey/people_in_office.png';

export const ChatBasedTalentSurveyPageFooter = () => {
  const {t} = useTranslation();

  return (
    <Box
      sx={{
        maxWidth: {xs: '100%', md: 950},
        width: '100%',
        mx: 'auto',
        bgcolor: 'background.paper',
        borderRadius: '5px',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: {xs: 'column', md: 'row'},
        boxShadow: '0px 2px 12px rgba(0,0,0,0.08)',
        marginTop: 3,
      }}
    >
      <Box
        component='img'
        src={peopleInOffice}
        alt=''
        sx={{
          width: {xs: '100%', md: '40%'},
          height: {xs: 200, md: 'auto'},
          objectFit: 'cover',
          display: 'block',
        }}
      />
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          textAlign: 'center',
          px: {xs: 3, md: 5},
          py: {xs: 3, md: 4},
          gap: 2,
        }}
      >
        <Typography variant='h2' component='p'>
          {t('talents.chatBasedSurvey.footerTitle')}
        </Typography>
        <Typography variant='body1'>{t('talents.chatBasedSurvey.footerDescription')}</Typography>
      </Box>
    </Box>
  );
};
